<template>
  <v-dialog
    v-model="valid"
    persistent
    max-width="650px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Alt Kullanıcıyı Güncelle</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form
            ref="form"
            lazy-validation
          >
            <v-layout row>
              <v-flex
                xs12
                md6
              >
                <v-text-field
                  v-model="form.name"
                  required
                  :rules="[$rules.empty('Ad')]"
                  :loading="loading"
                  :disabled="loading"
                  label="Ad"
                >
                </v-text-field>
              </v-flex>
              <v-flex
                xs12
                md6
              >
                <v-text-field
                  v-model="form.surname"
                  required
                  :rules="[$rules.empty('Soyad')]"
                  :loading="loading"
                  :disabled="loading"
                  label="Soyad"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.identity"
                  label="TC Kimlik Numarası"
                  prepend-inner-icon="mdi-card-account-details-outline"
                  :disabled="loading || !!originalIdentity"
                  :rules="[tcKimlikRule]"
                  maxlength="11"
                  counter="11"
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                      </template>
                      <span>SMS gönderiminde E-İmza doğrulaması için gereklidir</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                      v-model="form.username"
                      required
                      :rules="[$rules.empty('Kullanıcı Adı')]"
                      :loading="loading"
                      :disabled="loading"
                      label="Kullanıcı Adı">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <senders-or-message-types
                      label="Gönderici Adı"
                      no-data-text="Aktif Gönderici Adı bulunmuyor"
                      :default="defaultSender"
                      required
                      :rules="[$rules.selection('Gönderici Adı')]"
                      :items="senders"
                      :solo="false"
                      @on:model-update="selectedSender">
                  </senders-or-message-types>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                      v-model="form.sub_user_settings.credit_limit"
                      :rules="[$rules.empty('SMS Kredi Limiti')]"
                      label="SMS Kredi Limiti"
                      type="number"
                      required>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                      v-model="form.wp_credit"
                      :rules="[$rules.empty('Whatsapp Kredi Limiti')]"
                      label="Whatsapp Kredi Limiti"
                      type="number"
                      required>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                      v-model="form.phone"
                      v-mask="'0(###) ### ## ##'"
                      required
                      :rules="[$rules.empty('Telefon Numarası')]"
                      :loading="loading"
                      :disabled="loading"
                      @input="form.phone = $mask.unmasked(form.phone)"
                      label="Telefon Numarası">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <sms-verification :required="false" :phone="form.phone" @emitVerification="emitVerification"/>
                </v-flex>
              <v-flex
                xs12
                md6
              >
                <v-text-field
                  v-model="form.email"
                  :rules="[$rules.empty('E-mail')]"
                  :loading="loading"
                  :disabled="loading"
                  required
                  label="E-mail"
                >
                </v-text-field>
              </v-flex>
              <v-flex
                xs12
                md6
              >
                <v-select
                  v-model="defaultContact"
                  :items="[{k: 1, v: 'Yetkili'}, {k: 0, v: 'Yetkili Değil'}]"
                  item-text="v"
                  item-value="k"
                  label="Rehber Yetkisi"
                >
                </v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.password"
                  :loading="loading"
                  :disabled="loading"
                  label="Şifre"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click.stop="$emit('on:close')"
        >Kapat ve Devam et</v-btn>
        <v-btn
          color="primary"
          @click.stop="checkForm"
        >Güncelle</v-btn>
      </v-card-actions>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import SendersOrMessageTypes from '../SMSConstants/SendersOrMessageTypes.vue';
import SmsVerification from '@/views/Components/SmsVerification';

export default {
  name: 'UpdateSubUser',
  components: { SmsVerification,SendersOrMessageTypes },
  props: {
    valid: { type: Boolean },
    data: {},
    senders: { default: () => [] },
  },
  data: () => ({
    form: {
      sub_user_settings: {},
    },
  }),
  watch: {
    data(nv) {
      this.form = { ...nv };
    },
  },
  computed: {
    loading() {
      return Object.keys(this.form).length === 0 && this.form.constructor === Object;
    },
    originalIdentity() {
      return this.data && this.data.identity ? this.data.identity : null;
    },
    defaultContact: {
      get() {
        if (this.form.sub_user_settings.contacts === '1') {
          return {
            k: 1,
            v: 'Yetkili',
          };
        }
        return {
          k: 0,
          v: 'Yetkili Değil',
        };
      },
      set(v) {
        this.form.sub_user_settings.contacts = v.toString();
      },
    },
    defaultSender() {
      // eslint-disable-next-line no-prototype-builtins
      if (this.data.hasOwnProperty('sub_user_settings')) {
        if (this.data.sub_user_settings.sender === 'all') {
          return 'Hepsi';
        }

        return this.data.sub_user_settings.sender;
      }
      return '';
    },
  },
  methods: {
    tcKimlikRule(val) {
      if (!val || val.length === 0) return true;
      if (val.length !== 11 || !/^\d{11}$/.test(val)) return 'Geçersiz TC Kimlik Numarası';
      if (val[0] === '0') return 'Geçersiz TC Kimlik Numarası';
      const d = val.split('').map(Number);
      const sumOdd = d[0] + d[2] + d[4] + d[6] + d[8];
      const sumEven = d[1] + d[3] + d[5] + d[7];
      if (d[9] !== (sumOdd * 7 - sumEven) % 10) return 'Geçersiz TC Kimlik Numarası';
      if (d[10] !== (d[0]+d[1]+d[2]+d[3]+d[4]+d[5]+d[6]+d[7]+d[8]+d[9]) % 10) return 'Geçersiz TC Kimlik Numarası';
      return true;
    },
    selectedSender(v) {
      this.form.sub_user_settings.sender = v;
    },
    checkForm() {
      if (this.$refs.form.validate()) {
        if (this.form.sub_user_settings.sender === 'Hepsi') {
          this.form.sub_user_settings.sender = 'all';
        }
        this.$emit('on:save', this.form);
      }
    },
    emitVerification(data) {
      this.form = {
        ...this.form,
        ...data,
      };
    },
  },
};
</script>
